import React from 'react';
import { authToken, teladocApi } from '@td/api';

class ApiCollection extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      response: undefined
    }
  }

  componentDidMount(){
    if(!window.apiCollectionCache){
      window.apiCollectionCache = {};
    }

    //TODO: REFACTOR TO A REDUCER TO HANDLE CACHE
    if(window.apiCollectionCache[this.props.endpoint]){
      this.setState({response: window.apiCollectionCache[this.props.endpoint]});
    }else{
      teladocApi.get(this.props.endpoint, {}, authToken.get()).then( (resp) => {
        if(resp.status === 200){
          window.apiCollectionCache[this.props.endpoint] = resp.data;
          this.setState({response: resp.data})
        }
      });
    }
  }

  render(){
    if(this.state.response){
      return this.props.children(this.state.response);
    }else{
      return null;
    }
  }
}

export default ApiCollection;
